import React, {useState} from 'react';

export default function Share({selected}) {
	const [showNotice, setShowNotice] = useState(false);

	return (
		<div id="share">
			<ShareButton url={getShareLink()} canShare={navigator.canShare} />
			<div id="copy">
				<div>{(!navigator.canShare) ? 'Copy' : 'or copy' + ' the link below'}</div>
				<input type="text" id="link-copy-box" className="form-control form-control-sm p-0" value={getShareLink()} readOnly={true}
					onClick={(e) => {
						navigator.clipboard.writeText(e.target.value).then(() => {
							setShowNotice(true);
							window.dataLayer.push({
								"event": "mix_and_match",
								"event_category": "share",
								"event_label": "copy link"
							});
							setTimeout(() => {
								setShowNotice(false);
							}, 2000);
						});
				}}></input>
				<div id="link-copied" className={showNotice ? 'show' : 'hide'}>Link copied!</div>
			</div>
		</div>
	);

	function getShareLink() {
		const baseURL = new URL(window.location.href);
		const parameterObj = new URLSearchParams(baseURL.search);
		if (selected) {
			const params = {
				bgi: encodeURI(selected.table && selected.table.id ? selected.table.id : ''),
				chg: encodeURI(selected.charger && selected.charger.id ? selected.charger.id : ''),
				dp: encodeURI(selected.dinner && selected.dinner.id ? selected.dinner.id : ''),
				sp: encodeURI(selected.salad && selected.salad.id ? selected.salad.id : '')
			}
			for (const key in params) {
				parameterObj.set(key, params[key]);
			}
		}
		return baseURL.origin + baseURL.pathname + '?' + parameterObj.toString();
	}

	function ShareButton({url, canShare}) {
		const data = {
			title: 'Replacements Ltd.',
			text: 'Check out my signature place setting at replacements.com and create your own!\n\n' + url,
		};

		if (!canShare) {
			return null;
		}

		return (
			<button id="share-button" className="btn btn-primary" onClick={async () => {
				window.dataLayer.push({
					"event": "mix_and_match",
					"event_category": "share",
					"event_label": "share button"
				});
				try {
					await navigator.share(data);
				} catch (e) {
					console.log(e);
				}
			}}>Share</button>
		);
	}
}